/* projects/speaker-platform/src/app/pages/admin/admin-dashboard/admin-dashboard.component.scss */
.admindashboard h2 span {
  font-size: 18px;
  font-style: italic;
  color: #818181;
  font-weight: 400;
}
.admindashboard__stat {
  display: flex;
  justify-content: space-around;
  text-align: center;
}
.admindashboard__stat__item {
  font-size: 24px;
}
.admindashboard__stat__item span {
  display: block;
  font-size: 14px;
}
.admindashboard__onsitetoday {
  list-style: none;
  padding: 0;
  margin: 0;
}
.admindashboard__onsitetoday li {
  display: flex;
  justify-content: space-between;
}
.admindashboard__onsitetoday li:not(:last-child) {
  margin-bottom: 8px;
}
.admindashboard table thead tr th {
  font-size: 15px;
}
/*# sourceMappingURL=admin-dashboard.component-XEWTS6VB.css.map */
